export default __webpack_public_path__ + "static/media/welcome.fef09bd2.png";